import PaypalPaymentForStory from './PaypalPaymentForStory.vue';

export default PaypalPaymentForStory;
